export default __webpack_public_path__ + "navigation-examples-custom-segue-1200-17bd7326cc96f1c81baf80213fdbc185.webp";